export function submitAndReset(handleSubmit, form) {
  return async event => {
    try {
      const result = await handleSubmit(event);
      if (!result) {
        form.reset();
      }
      return result;
    } catch (error) {
      throw error;
    }
  };
}
